import { useContext } from 'react';
import { DeliveryPassContext } from './DeliveryPassContext';

const useDeliveryPassStatus = () => {
  const deliveryPassContext = useContext(DeliveryPassContext);

  return deliveryPassContext;
};

export default useDeliveryPassStatus;
